<template>
    <v-card target="_blank" :href="ConfigShopURL" class="shop-banner" color="#1664C0" elevation="0" rounded="0">
        <v-card-text class="text-center">
            <v-icon class="award-icon">mdi-license</v-icon>
            <span class="just-text">Get 100% certified ink, toner, paper, and office essentials — all shipped directly from the USA</span>
            <img class="flag-icon" src="https://flagcdn.com/us.svg" width="24" alt="USA flag">
        </v-card-text>
    </v-card>
</template>

<script>
import {CommonMixins} from "@/mixins/CommonMixins";

export default {
    mixins: [CommonMixins]
}
</script>
<style>
.just-text {
  color: #ffffff !important;
}
.shop-banner {
    display: flex;
    align-items:center;
    .award-icon {
        position: relative;
        top: -2px
    }
    .flag-icon {
        position: relative;
        top: 1px;
        margin-left: 5px;
    }
}
</style>
